import * as React from 'react';
import { SelectItem } from '@mantine/core';

// Enums
import enumDataSets from '../../../enums';

// Hooks
import { useCurrentParentLanguage } from '../../../hooks/useCurrentParentLanguage';

export const useEnumDataSet = () => {
    const { code: currentLanguage } = useCurrentParentLanguage();
    const getTranslatedDataSet = React.useCallback(
        (key: string): SelectItem[] => {
            const dataSet = enumDataSets?.[key];

            return Object.entries(dataSet).reduce(
                (acc, [key, value]) => [...acc, { value: key, label: value[currentLanguage] }],
                [] as SelectItem[]
            );
        },
        [currentLanguage]
    );
    const getTranslatedEnumValue = React.useCallback(
        (dataSetKey: string, valueKey: string): string => {
            return enumDataSets?.[dataSetKey]?.[valueKey]?.[currentLanguage] ?? '--';
        },
        [currentLanguage]
    );

    return { getTranslatedDataSet, getTranslatedEnumValue };
};

export default useEnumDataSet;
